import { t } from '@/shared/lib/i18n'

const ReportLiveIndicator = () => (
  <span
    className="inline-flex items-center gap-1.5 rounded-md border border-border bg-muted/40 px-2 py-0.5 text-xs"
    role="status"
  >
    <span className="size-1.5 shrink-0 rounded-full bg-sky-500" aria-hidden />
    <span className="font-medium text-foreground">{t('reports.monthly.liveIndicatorLabel')}</span>
    <span className="text-muted-foreground">— {t('reports.monthly.liveIndicatorDescription')}</span>
  </span>
)

export default ReportLiveIndicator
